import { EventTimeService } from './../../services/event.time.service';
import { VisitorEvent } from 'src/app/modules/shared/models/visitor.event';
import { Component, Input, Renderer2 } from '@angular/core';
import { ScriptService } from 'src/app/common/services/load.script/load.script.service';
import { VisitorEventService } from '../../services/visitor.event.service';

@Component({
  selector: 'ig-add-to-calendar-btn',
  templateUrl: './add.to.calendar.btn.component.html',
  styleUrls: ['./add.to.calendar.btn.component.scss'],
})
export class AddToCalendarBtnComponent {
  @Input() public event: VisitorEvent;

  constructor(
    public timeService: EventTimeService,
    private scriptService: ScriptService,
    private eventService: VisitorEventService,
    private renderer: Renderer2
  ) {
    const SCRIPT_PATH = `https://cdn.jsdelivr.net/npm/add-to-calendar-button@2`;

    if (!this.scriptService.isScriptExist(SCRIPT_PATH)) {
      const scriptElement = this.scriptService.loadJsScript(
        renderer,
        SCRIPT_PATH
      );
      scriptElement.onload = () => {
        console.log('Add to calendar script loaded');
      };
      scriptElement.onerror = () => {
        console.log('Could not load the script: ' + SCRIPT_PATH);
      };
    }
  }

  addToCalendar() {
    const config: Object = {
      name: this.event.name,
      dates: this.buildDates(),
      options: [
        'Apple|Calendar App',
        'Google|Google Calendar',
        'iCal',
        'Outlook.com',
        'Yahoo',
      ],
      timeZone: this.event.timezoneFormatter,
      location: this.event.isOnlineEvent
        ? 'Online event'
        : `${this.eventService.venueName(this.event)}, ${
            this.event.address.address
          }`,
    };

    const button = document.getElementById('add-to-calendar-button');
    window['atcb_action'](config, button);
  }

  private buildDates() {
    const dates = [];
    if (this.event.eventTimes.length) {
      this.event.eventTimes.forEach((time, i) => {
        const isAllDayEvent = this.timeService.isAllDayEvent(
          time.startTime,
          this.event.timezoneFormatter
        );

        let item = {
          name:
            this.event.name +
            (this.event.eventTimes.length > 1
              ? ` [${i + 1}/${this.event.eventTimes.length}]`
              : ''),
          description: this.event.description,
        };
        if (!isAllDayEvent) {
          item['startDate'] = this.timeService.toICSDate(
            time.startTime,
            this.event.timezoneFormatter
          );
          item['startTime'] = this.timeService.toICSTime(
            time.startTime,
            this.event.timezoneFormatter
          );
          item['endDate'] = this.timeService.toICSDate(
            time.startTime,
            this.event.timezoneFormatter
          );
          item['endTime'] = this.timeService.toICSTime(
            time.startTime,
            this.event.timezoneFormatter
          );
        } else {
          item['startDate'] = this.timeService.toICSDate(
            time.startTime,
            this.event.timezoneFormatter
          );
        }
        if (time.endTime && !isAllDayEvent) {
          item['endDate'] = this.timeService.toICSDate(
            time.endTime,
            this.event.timezoneFormatter
          );
          item['endTime'] = this.timeService.toICSTime(
            time.endTime,
            this.event.timezoneFormatter
          );
        }

        dates.push(item);
      });
    }
    return dates;
  }
}
